import { render, staticRenderFns } from "./PortalOfficeTable.vue?vue&type=template&id=49f1fdd2&scoped=true&"
import script from "./PortalOfficeTable.vue?vue&type=script&lang=ts&"
export * from "./PortalOfficeTable.vue?vue&type=script&lang=ts&"
import style0 from "./PortalOfficeTable.vue?vue&type=style&index=0&id=49f1fdd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1fdd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VChip,VContainer,VDataTable})
